const Sponsor = () => {
  return (
    <div>Sponsor</div>
  )
}

export default Sponsor